import { Injectable, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AppConfig } from '../../core/config/app.config';
import { FuseConfigService } from '../../../@fuse/services/config';

@Injectable({
  providedIn: 'root'
})
export class AppThemeService {
  private _scheme = new BehaviorSubject<string>('light');
  scheme$ = this._scheme.asObservable();

  constructor(private readonly fuseConfigService: FuseConfigService) {}

  watchScheme() {
    this.fuseConfigService.config$.subscribe((config: AppConfig) => {
      this.setScheme(config.scheme);
    });
  }

  setScheme(scheme: string): void {
    this._scheme.next(scheme);
  }

  getScheme(): string {
    return this._scheme.getValue();
  }
}
